var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "mb-2 d-flex flex-column item",
      class: { current: _vm.isSelected },
      on: { click: _vm.select },
    },
    [
      _c("div", { staticClass: "item-title d-flex align-items-center" }, [
        _c("div", { staticClass: "flex-grow-1 contact" }, [
          _vm.filemakerId
            ? _c("span", { staticClass: "filemaker-id" }, [
                _vm._v(_vm._s(_vm.filemakerId) + " "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.contactFirstName
            ? _c("span", { staticClass: "contact-first-name" }, [
                _vm._v(_vm._s(_vm._f("trim")(_vm.contactFirstName)) + ","),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("span", { staticClass: "contact-last-name" }, [
            _vm._v(_vm._s(_vm._f("trim")(_vm.contactLastName)) + " "),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "contact-phone-number" }, [
            _vm._v("(" + _vm._s(_vm.contactPhoneNumber) + ")"),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _vm.canEditContact
              ? _c(
                  "el-tooltip",
                  {
                    attrs: { content: "Edit Contact", placement: "top-start" },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "btn btn-link btn-link-purple",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.edit.apply(null, arguments)
                          },
                        },
                      },
                      [_c("i", { staticClass: "fas fa-edit" })]
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "message message-body mt-2 pt-2" }, [
        _vm._v(_vm._s(_vm.content)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }